import Yup from '../../../utils/yup'

const schema = Yup.object().shape({
  bottleType: Yup.string().nullable(),
})

export default schema
